function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-blue",
  d: "M12.01,13.43c-4.95,0-9.09,3.13-9.86,7.45c-0.05,0.29,0.03,0.59,0.22,0.82c0.19,0.23,0.47,0.36,0.77,0.36 H20.9c0.3,0,0.58-0.13,0.77-0.36c0.19-0.23,0.27-0.53,0.22-0.82C21.12,16.56,16.96,13.43,12.01,13.43z M4.46,20.06 c1.09-2.7,4.13-4.62,7.56-4.62c3.44,0,6.47,1.92,7.57,4.62H4.46z"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-blue",
  d: "M6.07,6.91h1.09c0,0.01,0,0.03,0,0.04c0,2.67,2.17,4.85,4.84,4.85c2.67,0,4.85-2.18,4.85-4.85 c0-0.01,0-0.03,0-0.04h1.09c0.47,0,0.87-0.32,0.98-0.78s-0.13-0.92-0.55-1.12l-5.94-2.8c-0.27-0.13-0.58-0.13-0.85,0l-5.93,2.8 c-0.42,0.2-0.65,0.67-0.55,1.12C5.19,6.59,5.6,6.91,6.07,6.91z M14.85,6.95c0,1.57-1.28,2.85-2.85,2.85 c-1.57,0-2.84-1.28-2.84-2.85c0-0.01,0-0.03,0-0.04h5.69C14.85,6.93,14.85,6.94,14.85,6.95z M12,4.22l1.47,0.7h-2.95L12,4.22z"
})));

var SvgIconFisherman = function SvgIconFisherman(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFisherman, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_fisherman.c173af2c.svg";
export { ForwardRef as ReactComponent };